import { IconBlocking, IconCheckCircleOutlined } from 'common/SVG/svg.common'
import { CardBolcking } from './dependencies.style'
import { useState } from 'react'
import { DeleteOutlined, DownOutlined, PlusOutlined, UpOutlined } from '@ant-design/icons'
import { Form } from 'antd'
import SelectDependencies from './Select/select.dependencies'

import './dependencies.css'
import { convertDate } from './ConverDate/convertdate.dependencies'

const BockingCommon = (props) => {
  const {
    typeTask,
    dataSelect,
    dataTasks,
    sendSearchDependencies,
    onChangeInSelect,
    form,
    onDeleteTaskByDepen,
    taskStatus,
  } = props
  const [isOpenAddWaiting, setIsOpenAddWaiting] = useState(false)
  const [isMore, setIsMore] = useState(false)


  const onDelete = async (item) => {
    onDeleteTaskByDepen(item, 'bocking')
  }

  const onChange = (_, option) => {
    onChangeInSelect(option, 'bocking')
  }

  const renderTaskWhenSelect = () => {
    return dataTasks?.map((item) => (
      <div className='group-task-assinge'>
        <div className='task-name'>
          <IconCheckCircleOutlined />
          <p>{item?.title}</p>
        </div>
        <div className='planned-date'>
          <p>{convertDate(item?.plan_start, item?.plan_end)}</p>
          <DeleteOutlined
            style={{ color: 'red' }}
            onClick={() => {
              onDelete(item)
            }}
          />
        </div>
      </div>
    ))
  }

  const onClickSelectSearchTask = () => {
    setIsOpenAddWaiting(true), sendSearchDependencies()
  }

  return (
    <CardBolcking>
      <div className='header-in-card'>
        <div className='group-text-header'>
          <IconBlocking />
          <p>BLOCKING</p>
        </div>
        <div className='border-task'>
          <p>{`${dataTasks.length} Task`}</p>
        </div>
      </div>
      <div className='text-discaption'>
        <p>Tasks that must be completed before this task</p>
      </div>
      <div
        className={
          dataTasks.length > 2 ? (!isMore ? 'more-style' : 'less-style') : 'less-style'
        }
      >
        {renderTaskWhenSelect()}
      </div>
      {dataTasks.length > 2 && (
        <div className='show-more-style'>
          {!isMore ? (
            <div onClick={() => setIsMore(!isMore)}>
              More <DownOutlined style={{ color: 'black' }} />
            </div>
          ) : (
            <div onClick={() => setIsMore(!isMore)}>
              Less <UpOutlined style={{ color: 'black' }} />
            </div>
          )}
        </div>
      )}
      <div className='group-add-task'>
        {taskStatus !== 'Done' &&
          (!isOpenAddWaiting ? (
            <div className='text-add-task' onClick={() => onClickSelectSearchTask()}>
              <PlusOutlined className='icon-add' />
              <p className='text-add'>Add task that is blocked</p>
            </div>
          ) : (
            <div className='form-add-task'>
              <Form form={form}>
                <Form.Item name='select'>
                  <SelectDependencies
                    typeTask={typeTask}
                    dataSelect={dataSelect}
                    onChange={onChange}
                  />
                </Form.Item>
              </Form>
              <p className='btn-done' onClick={() => setIsOpenAddWaiting(false)}>
                Done
              </p>
            </div>
          ))}
      </div>
    </CardBolcking>
  )
}

export default BockingCommon
